module.exports = __webpack_public_path__ + "static/img/biotechnology_1.96983d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/biotechnology_1.png
// module id = aAHU
// module chunks = 6